import StepIndicator from './StepIndicator';
import './StepIndicator.scss';

export default StepIndicator;
